<sh-language-picker
  class="d-flex justify-content-end m-2"
></sh-language-picker>

<div class="login-wrapper">
  <div class="login-form">
    <section>
      <div class="login-logo">{{ 'shared.branding.shipm8' | translate }}</div>
      <div class="d-flex flex-column">
        <h5 class="mt-4 text-center">
          <strong>{{ 'account.register.thankyou.title' | translate }}</strong>
        </h5>
        <span class="mt-4 text-justify">
          {{ 'account.register.thankyou.text' | translate }}
        </span>
      </div>
    </section>
  </div>
</div>
